export const YoutubePosts = [
  {
    id: 1,
    url: "https://youtube.com/shorts/6AHIDaDFey4?si=ykvbhUBjsems6JzS",
    caption: "Campus Tour of British Spring College",
    description:
      "This video shows the landmax of B.S.C , it's aesthetically pleasing view and the ambience that surrounds the learning environment",
  },
  {
    id: 2,
    url: "https://www.youtube.com/watch?v=m-hK7IKDtlI&ab_channel=DENKELLYSTUDIOEventPhotographyandVideography",
    caption: "Excitement Fills the Air as We Resume Academic Activities!",
    description:
      "We're thrilled to announce that our students returned to campus with enthusiasm and eagerness on September 14th, 2023, marking the beginning of a new academic session!",
  },
  {
    id: 3,
    url: "https://youtube.com/shorts/?v=6AHIDaDFey4&si=ykvbhUBjsems6JzS",
    caption: "Celebrating Our Graduates!",
    description:
      "We are grateful to have been part of your journey and will fondly remember the Class of 2024 for the character of patience and discipline. Though you will be missed at BSC, your presence is needed beyond our walls. Stay focused, positive, and remember that God is your strength.",
  },
  {
    id: 4,
    url: "https://youtube.com/shorts/?v=6AHIDaDFey4&si=ykvbhUBjsems6JzS",
    caption: "Celebrate Excellence, Inspire Tomorrow:",
    description: "Olivia Industries Ltd showcasing the values that define our brand.",
  },
];
